import { makeStyles } from '@mui/styles'
import Colors from 'utils/Colors'

const styles = makeStyles(() => ({
  root: {
    width: '30%',
    minWidth: 430,
    height: '',
    display: 'flex',
    alignItems: 'flex-start',
    justifyContent: 'flex-start',
    flexDirection: 'column',
    fontSize: 11,
    backgroundColor: Colors.white,
    padding: '1.5rem',
    paddingBottom: '0.75rem',
    borderRadius: 5,
    '@media (max-width: 1500px)': {
      width: '100%',
    },
    '@media (max-width: 500px)': {
      minWidth: 'calc(100vw - 5rem)',
    },
  },
  
  header: {
    width: '100%',
    display: 'flex',
    alignItems: 'center',
    justifyContent: 'flex-start',
    gap: '2rem',
    padding: '0 0 0.75rem 0 ',
  },
  
  listItem: {
    width: '100%',
    display: 'flex',
    alignItems: 'center',
    justifyContent: 'space-between',
    gap: '2rem',
    padding: '0.83rem 1.25rem',
    borderBottom: `1px solid ${Colors.lightGray}`,
    '&:last-child':{
      borderBottom: 'none',
    },
  },
  
  status: {
    padding: '0.5rem 1rem',
    textTransform: 'uppercase',
    color: Colors.white,
    backgroundColor: Colors.green,
    borderRadius: '3px',
    fontWeight: 'bold',
  },
  
}))

export default styles
